import React, { useEffect, useState } from "react";
import "./Users.css";
import { NavLink, useSearchParams } from "react-router-dom";
import HeaderUser from "../../components/Header/HeaderUser";
import { MdSearch, MdFilterList, MdMoreHoriz } from "react-icons/md";
import Pagination from "../../components/MiniComponents/Pagination";
import toast, { Toaster } from "react-hot-toast";

import {
  getAllUsers,
  getActiveUsers,
  getInactiveUsers,
  blockUserApi,
  unblockUserApi,
} from "../../api/UserApi";

import useDebounce from "../../hooks/useDebounce";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  // const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState(null);
  // const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;
  const search = searchParams.get("search") || "";

  const debouncedSearch = useDebounce(search, 1000);

  const limit = 10;

  const handlePageChange = (newPage) => {
    setSearchParams({
      page: newPage,
      search,
    });
  };

  const handleSearch = (value) => {
    setSearchParams({
      page: 1,
      search: value,
    });
  };

  // 🔹 Fetch users
  const fetchUsers = async () => {
    try {
      // let res;

      // if (filterType === "active") {
      //   res = await getActiveUsers();
      // } else if (filterType === "inactive") {
      //   res = await getInactiveUsers();
      // } else {
      //   res = await getAllUsers(page, 10, search);
      // }
      const res = await getAllUsers(page, limit, search, filterType);
      console.log("users api resp:", res);
      // setUsers(res.data);
      setUsers(res?.data?.formattedUsers || []);
      setTotalPages(res?.data?.totalPages || 1);
    } catch (err) {
      console.error("Fetch users failed:", err);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [filterType, page, debouncedSearch]);

  // 🔹 Block user
  const blockUser = async (userId) => {
    try {
      const res = await blockUserApi(userId);
      if (res?.success) {
        toast.success("User Blocked.");
      }
      fetchUsers();
      setActiveMenu(null);
    } catch (err) {
      console.error("Block user failed:", err);
    }
  };

  // 🔹 Unblock user
  const unblockUser = async (userId) => {
    try {
      const res = await unblockUserApi(userId);
      if (res?.success) {
        toast.success("User Unblocked.");
      }
      fetchUsers();
      setActiveMenu(null);
    } catch (err) {
      console.error("Unblock user failed:", err);
    }
  };

  // 🔹 Search filter
  // const filteredUsers = users.filter((u) =>
  //   u.name?.toLowerCase().includes(search.toLowerCase()),
  // );

  return (
    <div>
      <HeaderUser />

      <div className="entire">
        <div className="userlist-card">
          <div className="userlist-title">
            <h3>User List</h3>
            <p>View and manage all users</p>
          </div>

          <div className="userlist-controls">
            <div className="search-boxx">
              <MdSearch />
              <input
                type="text"
                placeholder="Search by username"
                value={search}
                // onChange={(e) => setSearch(e.target.value)}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>

            <div className="filter-wrapper">
              <button onClick={() => setShowFilter(!showFilter)}>
                Filter <MdFilterList />
              </button>

              {showFilter && (
                <div className="filter-dropdown">
                  <label>
                    <input
                      type="radio"
                      name="status"
                      checked={filterType === "active"}
                      onChange={() => setFilterType("active")}
                    />
                    Active
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="status"
                      checked={filterType === "inactive"}
                      onChange={() => setFilterType("inactive")}
                    />
                    Inactive
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="status"
                      checked={filterType === null}
                      onChange={() => setFilterType(null)}
                    />
                    All
                  </label>
                </div>
              )}
            </div>
          </div>

          <div className="table-contain">
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Username</th>
                  <th>Account Type</th>
                  <th>Login Detail</th>
                  <th>Coin Balance</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {users?.map((user, index) => (
                  <tr key={user._id}>
                    <td>{index + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.userType}</td>
                    <td>{user.guestId}</td>
                    <td>{user.coins ?? 0}</td>

                    <td style={{ color: user.isBlocked ? "red" : "green" }}>
                      {user.isBlocked ? "Blocked" : "Active"}
                    </td>

                    <td className="action-cell">
                      <MdMoreHoriz
                        onClick={() =>
                          setActiveMenu(activeMenu === index ? null : index)
                        }
                      />

                      {activeMenu === index && (
                        <div className="action-menu">
                          <span onClick={() => blockUser(user._id)}>Block</span>
                          <span onClick={() => unblockUser(user._id)}>
                            Unblock
                          </span>

                          {/* <NavLink to={`/Layout/Viewuser/${user._id}`}>
  <span>View user</span>
</NavLink> */}
                          <NavLink to={`/Layout/Viewuser/${user._id}`}>
                            <span>View user</span>
                          </NavLink>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
              className="mt-2"
            >
              <Pagination
                currentPage={page}
                totalPages={totalPages}
                // onPageChange={(p) => setPage(p)}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
